import { Autocomplete, CircularProgress, TextField } from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import QueryError from "../../../../components/QueryError";
import { FilterModel } from "../../models/FilterModel";
import { StreetModel } from "../models/StreetModel";
import { useStreetsQuery } from "../queries/useStreetsQuery";
const isOptionEqualToValue = (option: StreetModel, value: StreetModel) =>
  option.id === value.id;

const StreetSelect = () => {
  const { resetField } = useFormContext<FilterModel>();
  const {
    data: streets,
    error,
    isError,
    isRefetching,
    refetch,
    isLoading,
  } = useStreetsQuery();

  if (isError) {
    return (
      <QueryError
        {...{
          error,
          refetch,
          unknownMessage: "Nie udało się pobrać listy ulic",
          ariaUnknownMessage:
            "Nie udało się pobrać listy ulic; spróbuj ponownie, klikając w przycisk spróbuj ponownie",
        }}
      />
    );
  }
  const loading = isLoading || (isRefetching && isError);
  const options =
    streets?.map((street) => ({ ...street, label: street.street })) ?? [];

  return (
    <Controller<FilterModel, "street">
      name="street"
      render={({
        field: { onChange, onBlur, value },
        fieldState: { error },
      }) => (
        <Autocomplete
          isOptionEqualToValue={isOptionEqualToValue}
          onBlur={onBlur}
          options={options}
          noOptionsText={"Baza danych punktów adresowych jest pusta."}
          loading={loading}
          loadingText="Ładowanie..."
          renderInput={(params) => (
            <TextField
              {...params}
              label={"Ulica"}
              required
              error={Boolean(error)}
              helperText={error?.message}
              InputLabelProps={{
                "aria-label": "Ulica (wymagane)",
              }}
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <>
                    {loading ? (
                      <CircularProgress color="inherit" size={20} />
                    ) : null}
                    {params.InputProps.endAdornment}
                  </>
                ),
              }}
            />
          )}
          value={value}
          onChange={(_, newValue) => {
            onChange(newValue);
            resetField("addressPoint");
          }}
        />
      )}
    />
  );
};

export default StreetSelect;
